// extracted by mini-css-extract-plugin
export default {"navbar_link":"Navbar_navbar_link__SnMha"};